import axios from 'axios'
import config from '../config'

export default {
    getProviders() {
        return axios.get(config.publicPath + 'reputation_providers',
            {
                params: {},
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },
    getProvider(id) {
        return axios.get(config.publicPath + 'reputation_providers/' + id, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    },
    updateProvider(id, formData) {
        return axios.put(config.publicPath + 'reputation_providers/' + id, formData, {
            headers: {
                'Content-Type': 'application/json',
            },
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
}
